// assets/ingredients-highlights.js
console.log('KK ingredients: script loaded (final stable version)');

(function() {

  // --- ALLERGEN LIST ---
  var allergens = [
    "gluten","hvede","rug","byg","havre","spelt","khorasan",
    "skaldyr","fisk",

    // Jordnød / peanuts
    "jordnødder",
    "peanuts",

    // Soja
    "soja","sojabønne","sojabønner",

    // Mælk – inkl. svenske varianter
    "mælk","mjölk","mjolk",

    // Specifikke nødder
    "mandel","hasselnød","hasselnødder","valnød","cashew","pekan",
    "paranød","pistacie","macadamia",

    // Det generelle "nødder" håndteres med special-regex
    "nødder",

    "selleri","sennep","sesam","sesamfrø",
    "svovldioxid","sulfit","sulfitter",
    "lupin","bløddyr"
  ];

  // --- CLEAN + BOLD FUNCTION ---
  function boldAllergensIn(el) {
    if (!el) return;
    var html = el.innerHTML;
    if (!html) return;

    // 1) Fjern al eksisterende bold i ingrediensfeltet
    html = html.replace(/<\/?strong[^>]*>/gi, '');

    // 2) Gennemgå hvert allergen
    for (var i = 0; i < allergens.length; i++) {
      var word = allergens[i];
      var safe = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re;

      if (word === 'nødder') {
        // ---- SPECIAL CASE ----
        // Match kun fristående "nødder" – IKKE inde i jordnødder
        re = new RegExp('(^|[^A-Za-zÆØÅæøå])(' + safe + ')(?![A-Za-zÆØÅæøå])', 'gi');

        html = html.replace(
          re,
          '$1<strong class="kk-allergen">$2</strong>'
        );
      } 
      else {
        // ---- NORMAL CASE ----
        // Match også inde i sammensatte ord (sødmælkspulver, jordnødder osv.)
        re = new RegExp('(' + safe + ')', 'gi');

        html = html.replace(
          re,
          '<strong class="kk-allergen">$1</strong>'
        );
      }
    }

    // 3) Ryd op i evt. dobbelte strong-tags
    html = html
      .replace(/(<strong class="kk-allergen">)+/g, '<strong class="kk-allergen">')
      .replace(/(<\/strong>)+/g, '</strong>');

    el.innerHTML = html;
  }

  // --- FIND INGREDIENSLISTE PANEL ---
  function findIngredientPanels(scope) {
    if (!scope) scope = document;
    var panels = [];
    var selectors =
      'summary, button[aria-controls], .accordion__title, .Collapsible__Button, .cc-accordion__heading, ' +
      '[role="button"], h2, h3, .h2, .h3, .section-header, .product__accordion-title';

    var headings = scope.querySelectorAll(selectors);

    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var txt = (h.textContent || '').toLowerCase().trim();
      if (!txt) continue;

      if (txt.includes('ingrediensliste') || txt.includes('ingredienser')) {
        var panel = null;

        // via aria-controls
        var ctrl = h.getAttribute && h.getAttribute('aria-controls');
        if (ctrl) {
          panel = document.getElementById(ctrl);
        }

        // via accordion container
        if (!panel) {
          var container = h.closest &&
            h.closest('details, .accordion, .Collapsible, .cc-accordion, .product__accordion, .collapsible, .collapsible-content');

          if (container) {
            panel = container.querySelector(
              '.accordion__content, .Collapsible__Inner, .cc-accordion__panel, [data-accordion-content],' +
              '.content, .rte, [role="region"], .product__accordion-content, .collapsible__content'
            );
          }
        }

        // fallback: next sibling
        if (!panel && h.parentElement && h.parentElement.nextElementSibling) {
          var next = h.parentElement.nextElementSibling;
          if (next.textContent && next.textContent.length > 10) {
            panel = next;
          }
        }

        if (panel && panels.indexOf(panel) === -1) {
          panels.push(panel);
        }
      }
    }

    return panels;
  }

  // --- RUN ON PRODUCT PAGE ONLY ---
  function run() {
    var isProduct =
      (document.body &&
        document.body.className.indexOf('template-product') !== -1) ||
      /\/products\//.test(window.location.pathname);

    if (!isProduct) return;

    var panels = findIngredientPanels(document);
    for (var i = 0; i < panels.length; i++) {
      boldAllergensIn(panels[i]);
    }
  }

  // --- INIT ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
